import Vue from 'vue'
import Router from 'vue-router'
import DefaultComponent from './components/DefaultComponent'
// import DevRoot from './components/DevRoot'
import AccountRoot from './components/AccountRoot'
import PurchaseLicense from './components/AccountChildren/PurchaseLicense'
import MsgRoot from './components/MsgRoot'
import MsgCreate from './components/MsgChildren/MsgCreate'
import ScheduledRoot from './components/ScheduledRoot'
import AppView from './components/AppView'
import AboutMileyRoot from './components/AboutMileyRoot'
import InitialStart from './components/AccountChildren/InitialStart'
import SignUp from './components/AccountChildren/SignUp'
import AccountEdit from './components/AccountChildren/AccountEdit'
import ErrorSuspend from './components/CommonChildren/ErrorSuspend'
import OpenAuth from './components/auth/OpenAuth'
import callback from './components/auth/callback'

Vue.use(Router)

// const extend = name => ({ name, extends: Template });

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'DefaultComponent',
      component: DefaultComponent
    },
    // {
    //   path: '/DevRoot',
    //   name: 'DevRoot',
    //   component: DevRoot
    // },
    {
      path: '/AccountRoot',
      name: 'AccountRoot',
      component: AccountRoot
    },
    {
      path: '/InitialStart',
      name: 'InitialStart',
      component: InitialStart
    },
    {
      path: '/AccountRoot/SignUp',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/AccountRoot/OpenAuth',
      name: 'OpenAuth',
      component: OpenAuth
    },
    {
      path: '/AccountRoot/PurchaseLicense',
      name: 'PurchaseLicense',
      component: PurchaseLicense
    },
    {
      path: '/auth/callback',
      name: 'callback',
      component: callback
    },
    {
      path: '/AccountRoot/AccountEdit',
      name: 'AccountEdit',
      component: AccountEdit
    },
    {
      path: '/AppView',
      name: 'AppView',
      component: AppView
    },
    {
      path: '/MsgRoot',
      name: 'MsgRoot',
      component: MsgRoot
    },
    {
      path: '/MsgRoot/MsgCreate',
      name: 'MsgCreate',
      component: MsgCreate
    },
    {
      path: '/ScheduledRoot',
      name: 'ScheduledRoot',
      component: ScheduledRoot
    },
    {
      path: '/AboutMileyRoot',
      name: 'AboutMileyRoot',
      component: AboutMileyRoot
    },
    {
      path: '/ErrorSuspend',
      name: 'ErrorSuspend',
      component: ErrorSuspend
    }

  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router.js